export default __webpack_public_path__ + "static/media/list_card2.f64a21af.svg";